import authApi from './auth';
import checkinApi from './checkin';
import companyApi from './company';
import customizationApi from './customization';
import deliveriesApi from './deliveries';
import hostZonesApi from './hostZones';
import hostsApi from './hosts';
import invitesApi from './invites';
import meetingLinksApi from './meeting-links';
import meetingLocationsApi from './meeting-locations';
import meetingTypesApi from './meeting-types';
import meetingsApi from './meetings';
import notificationTokenApi from './notificationToken';
import notificationEventsApi from './notification_events';
import qrcodesApi from './qrcodes';
import userApi from './user';
import visitZonesAccessApi from './visitZonesAccess';
import visitsApi from './visits';
import waccessIntegrationApi from './waccessIntegration';
import zonesApi from './zones';
import SpaceManagementApi from './spaceManagement';

export {
  authApi,
  userApi,
  companyApi,
  notificationTokenApi,
  invitesApi,
  meetingLinksApi,
  meetingsApi,
  customizationApi,
  deliveriesApi,
  hostsApi,
  visitsApi,
  meetingTypesApi,
  meetingLocationsApi,
  checkinApi,
  waccessIntegrationApi,
  notificationEventsApi,
  qrcodesApi,
  hostZonesApi,
  zonesApi,
  visitZonesAccessApi,
  SpaceManagementApi,
};
